import sendings from './sendings'

const notificationsEvents = {
  hints: {
    balance: {
      limit: {
        balance: 'Notificaremos cuando el balance sea {amount}',
        onLimit: 'Al alcanzar el balance',
        onNullBalance: 'Notificaremos cuando el balance sea cero',
        noLimit: '<límite no especificado>',
        notifyBy: 'notificar por',
        noNotifications: '<no notificar>',
        overdraft: ' + sobregiro del usuario',
        extraRecipients: 'Notificaciones sobre el estado del balance de todos los usuarios del sistema',
        invoice: 'Adjuntar factura por {amount}',
        empty: 'No hay ningún límite configurado.<br>No recibirá notificaciones sobre su balance.',
        permission: {
          read: 'No tiene permisos para cambiar límites.',
          write: 'Puede agregar un límite haciendo clic en el botón "Agregar" a continuación.'
        }
      }
    }
  },

  labels: {
    balance: {
      limit: {
        host: 'Host',
        port: 'Puerto',
        from: 'De',
        login: 'Nombre de usuario',
        password: 'Contraseña',
        limit: 'Límite',

        include: {
          overdraft: 'Incluir sobregiro',
          invoice: {
            detach: 'Desadjuntar factura por {amount}',
            send: 'Enviar factura por {amount}'
          }
        },

        notInclude: {
          overdraft: 'No incluir sobregiro',
          invoice: 'No adjuntar factura'
        },

        invoice: {
          amount: 'Monto de la factura'
        }
      }
    },

    providers: {
      health: {
        recipients: 'Destinatarios de notificaciones sobre el estado de los proveedores'
      }
    }
  },

  buttons: {
    balance: {
      limit: {
        invoice: {
          attach: 'Adjuntar factura',
          detach: 'Desadjuntar factura'
        }
      }
    }
  }
}

export const paths = {
  billings: {
    autoAccrual: 'Recarga automática',
    billOnErrors: 'Tarificar SMS en caso de error',
    currency: 'Moneda',
    overdraft: 'Descubierto',
    processChildrenOperations: 'Procesar operaciones financieras de usuarios secundarios como propias'
  },

  integrations: {
    pyrus: {
      credentials: 'Credenciales para conectar con Pyrus'
    }
  },

  referral: {
    billings: {
      processedChildOperations: 'Procesar operaciones financieras del programa de referidos de usuarios secundarios como propias'
    }
  },

  reports: {
    maxConcurrentGenerating: 'Cantidad máxima de informes generados simultáneamente'
  },

  sendings: {
    allowDuplicates: 'Permitir mensajes duplicados',
    sendernamesCheck: 'Restringir nombres de remitente por tipo',
    patternsCheck: 'Verificación obligatoria por plantilla de moderación para tipos',

    duplicates: {
      hashFields: 'Campos para verificación de duplicados',
      timeout: 'Tiempo de bloqueo de duplicados'
    },

    phoneNumber: {
      checkMobile: 'Verificar números móviles'
    },

    rateLimit: {
      maxAmount: 'Cantidad de mensajes',
      timeout: 'Intervalo de tiempo'
    },

    tilda: {
      sendFromForms: 'Permitir envío de mensajes desde formularios Tilda'
    }
  },

  smpp: {
    defaultMessageType: 'Tipo de mensaje por defecto',
    enabled: 'SMPP habilitado',
    ipWhitelist: 'Lista blanca',
    rudeMode: 'Modo rudo'
  },

  webhooks: 'Webhooks',

  notifications: {
    email: {
      recipients: 'Destinatarios de notificaciones por email'
    },

    sms: {
      recipients: 'Destinatarios de notificaciones por SMS'
    }
  },

  websocket: {
    channels: 'Canales'
  }
}
export const descriptions = {
  billings: {
    overdraft: 'El sobregiro es la cantidad que puede exceder su saldo. Si no se especifica el sobregiro, es igual a cero.',
    autoAccrual: 'La recarga automática permite recargar el saldo automáticamente al alcanzar el valor umbral.',
    processChildrenOperations: 'Si está habilitado, las operaciones financieras de los usuarios secundarios se procesarán como propias.',
    billOnErrors: 'Si está habilitado, se cobrará una tarifa en caso de error al enviar SMS.',
    currency: 'La moneda en la que se realizarán las operaciones financieras.'
  },

  integrations: {
    pyrus: {
      credentials: 'El nombre de usuario y la clave de seguridad se pueden obtener en la configuración de Pyrus.'
    }
  },

  notifications: {
    enabled: 'Activa o desactiva todas las notificaciones.',

    email: {
      recipients: 'Indique las direcciones de correo electrónico a las que se enviarán las notificaciones. Las direcciones deben estar separadas por comas o saltos de línea.'
    },

    sms: {
      recipients: 'Indique los números de teléfono a los que se enviarán las notificaciones. Los números deben estar separados por comas o saltos de línea. Formato de número: +79991234567.'
    }
  },

  referral: {
    billings: {
      processedChildOperations: 'La recompensa que usted recibe por las operaciones de los usuarios secundarios. Se pueden definir como máximo dos filas: una para los abonos y otra para los cargos, no se puede repetir la misma fuente. Para cada fila indique el porcentaje del importe de la operación y el importe mínimo y máximo de la recompensa.'
    }
  },

  reports: {
    maxConcurrentGenerating: 'Debe ser mayor o igual a 0 y menor que 10.'
  },

  sendings: {
    allowDuplicates: 'Permite el envío de mensajes duplicados. Si está deshabilitado, los duplicados serán bloqueados.',
    sendernamesCheck: 'Restringe los nombres de remitente por tipo. Si está habilitado, los nombres de remitente se verificarán según las plantillas.',
    patternsCheck: 'Verificación obligatoria según la plantilla de moderación por tipo. Si está habilitado, los mensajes se verificarán según las plantillas de moderación.',

    duplicates: {
      hashFields: 'Campos por los que se verificará la existencia de duplicados. Si no se especifican campos, se verificarán todos los campos del mensaje.',
      timeout: 'Tiempo de bloqueo de duplicados en segundos. Si no se especifica el tiempo, los duplicados se bloquearán durante 24 horas.'
    },

    phoneNumber: {
      checkMobile: 'Valida el tipo de número: solo los números móviles se consideran válidos. Los fijos y otros tipos no móviles se consideran no válidos.'
    },

    rateLimit: {
      maxAmount: 'La cantidad máxima de mensajes que se pueden enviar durante el intervalo de tiempo especificado.',
      timeout: 'Intervalo de tiempo en segundos durante el cual se aplicará el límite de mensajes.'
    },

    tilda: {
      sendFromForms: 'Permite el envío de mensajes desde formularios de Tilda. Si está deshabilitado, los mensajes de formularios de Tilda serán bloqueados.'
    }
  },

  smpp: {
    defaultMessageType: 'El tipo de mensaje que se utilizará por defecto para SMPP.',
    enabled: 'Activa o desactiva SMPP. Si está deshabilitado, SMPP no estará disponible.',
    ipWhitelist: 'Solo direcciones IP válidas, separadas por "coma" o "salto de línea".',
    rudeMode: 'Modo rudo de SMPP.'
  },

  websocket: {
    channels: 'Canales a los que se enviarán las notificaciones.'
  }
}

export default {
  title: 'Configuraciones del usuario',

  titles: {
    sendings: 'Mensajes',
    billings: 'Operaciones financieras',
    referral: 'Programa de referidos',
    websocket: 'Websocket',
    smpp: 'SMPP',
    webhooks: 'Webhooks',
    notifications: 'Notificaciones',
    integrations: 'Integraciones',
    reports: 'Informes'
  },

  subtitles: {
    notifications: {
      events: {
        me: 'Notificaciones para sí mismo',
        child: 'Notificaciones para usuarios secundarios'
      }
    },

    webhooks: {
      onStatusChange: 'Al cambiar el estado',
      onIncomingMessage: 'Entrantes',
      request: 'Parámetros de la solicitud',
      successOn: 'Condiciones de éxito de la solicitud',
      statuses: 'Estados'
    }
  },

  dialogs: {
    titles: {
      webhooks: {
        onStatusChange: 'Al cambiar el estado',
        onIncomingMessage: 'Entrantes'
      }
    }
  },

  paths,
  descriptions,

  labels: {
    notSet: 'No establecido',
    notChosen: 'No seleccionado',

    billings: {
      overdraft: 'Sobregiro',
      processChildrenOperations: 'Procesar las operaciones financieras de usuarios secundarios como propias',
      billOnErrors: 'Cobrar SMS en caso de error',
      currency: 'Moneda',

      autoAccrual: {
        limit: 'Umbral',
        requiredBalance: 'Saldo necesario'
      }
    },

    integrations: {
      pyrus: {
        credentials: {
          login: 'Nombre de usuario',
          security_key: 'Clave de seguridad'
        }
      },

      yclients: {
        applicationCredentials: {
          id: 'ID de la aplicación',
          token: 'Token de la aplicación'
        }
      }
    },

    notifications: {
      extraRecipients: 'Destinatarios de notificaciones',
      type: 'Método de notificación',
      events: notificationsEvents.labels,
      childrenUsersEvents: notificationsEvents.labels
    },

    referral: {
      billings: {
        processedChildOperations: 'Programa de referidos'
      }
    },

    reports: {
      maxConcurrentGenerating: 'Cantidad máxima de informes generados simultáneamente'
    },

    sendings: {
      allowDuplicates: 'Permitir duplicados de mensajes',

      rateLimit: {
        maxAmount: 'Número de mensajes',
        timeout: 'Intervalo de tiempo'
      },

      duplicates: {
        hashFields: 'Campos para verificar duplicados',
        timeout: 'Tiempo de bloqueo de duplicados'
      },

      tilda: {
        sendFromForms: 'Permitir envío de mensajes desde formularios de Tilda'
      },

      phoneNumber: {
        checkMobile: 'Verificar números móviles'
      }
    },

    smpp: {
      enabled: 'SMPP habilitado',
      rudeMode: 'Modo bruto de SMPP',
      defaultMessageType: 'Tipo de mensaje predeterminado para SMPP',
      ipWhitelist: 'Lista blanca',
      ipAddresses: 'Direcciones IP',
      confirm: 'Confirmación de guardado'
    },

    webhooks: {
      url: 'URL',
      method: 'Método',
      headers: 'Encabezados',
      body: 'Cuerpo',
      maxConnections: 'Conexiones',

      successOn: {
        status: 'Estado',
        body: 'Cuerpo'
      },

      extras: {
        statuses: sendings.statuses
      }
    },

    websocket: {
      channels: 'Canales'
    }
  },

  hints: {
    billings: {
      autoAccrual: {
        limit: 'Umbral',
        requiredBalance: 'Saldo necesario'
      }
    },

    integrations: {
      pyrus: {
        credentials: 'El nombre de usuario y la clave de seguridad se obtienen en la configuración de Pyrus.'
      }
    },

    notifications: {
      events: notificationsEvents.hints,
      childrenUsersEvents: notificationsEvents.hints
    },

    referral: {
      billings: {
        processedChildOperations: {
          source: 'Fuente',
          percent: 'Porcentaje',
          limitMin: 'Mínimo',
          limitMax: 'Máximo'
        }
      }
    },

    reports: {
      maxConcurrentGenerating: 'Debe ser mayor o igual a 0 y menor que 10.'
    },

    sendings: {},

    smpp: {
      ipAddresses: 'Solo direcciones IP válidas, separador "coma", "salto de línea".'
    },

    webhooks: {
      maxConnections: 'Cantidad máxima. Por defecto 10.',

      successOn: {
        status: 'Se pueden usar expresiones regulares. Por defecto 200.',
        body: 'Se pueden usar expresiones regulares.'
      }
    },

    websocket: {}
  },

  buttons: {
    notifications: {
      events: notificationsEvents.buttons,
      childrenUsersEvents: notificationsEvents.buttons
    }
  },

  warnings: {
    smpp: {
      ipAddresses: 'Algunas de las direcciones IP especificadas no pasaron la verificación de validez.<br>Si necesita guardar estas direcciones, asegúrese de que sean correctas, luego ingréselas nuevamente en el campo "Direcciones IP" y haga clic en "Guardar".<br>Si las direcciones siguen siendo incorrectas, esta ventana no se cerrará y la lista a continuación se actualizará con las nuevas direcciones incorrectas.'
    }
  },

  items: {
    websocket: {
      channels: {
        dbUpdates: 'Actualización de la base de datos',
        everything: 'Todo',
        health: 'Salud de la plataforma',
        sendingStatusUpdates: 'Actualización del estado de los envíos',
        providersStatesUpdates: 'Actualización del estado de los proveedores'
      }
    }
  },

  snackbars: {
    updated: 'Configuración actualizada exitosamente.'
  }
}
